import React from 'react';
import { Wrench, Truck, Sparkles, ArrowRight } from 'lucide-react';

const TRUCK_FACTORY_LOGO =
  'https://customer-assets-wrfwihn1.emergentagent.net/job_a0e7f17d-9159-4d2a-a971-2aaa914eeb6a/artifacts/hdeby03t_image.jpeg';
const ELDERS_LOGO =
  'https://customer-assets-wrfwihn1.emergentagent.net/job_a0e7f17d-9159-4d2a-a971-2aaa914eeb6a/artifacts/p12muae5_image.png';
const KPTCC_LOGO =
  'https://customer-assets-wrfwihn1.emergentagent.net/job_a0e7f17d-9159-4d2a-a971-2aaa914eeb6a/artifacts/w4jij5c6_IMG_0026.webp';
const JOHNSONS_LOGO =
  'https://customer-assets-wrfwihn1.emergentagent.net/job_a0e7f17d-9159-4d2a-a971-2aaa914eeb6a/artifacts/92ee140ecbc3b154_image.png';

const services = [
  { icon: Truck, label: 'Truck Recovery' },
  { icon: Wrench, label: 'Repairs' },
  { icon: Sparkles, label: 'Restorations' },
];

const TruckFactoryStrip = () => {
  return (
    <section className="bg-white py-8 sm:py-12 md:py-16" data-testid="truck-factory-strip">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#1e3a5f] via-[#254d7f] to-[#0f2340] text-white">
          <div
            className="absolute -top-16 -right-16 w-64 h-64 bg-red-500/30 rounded-full blur-3xl"
            aria-hidden
          />
          <div
            className="absolute -bottom-16 -left-16 w-64 h-64 bg-white/10 rounded-full blur-3xl"
            aria-hidden
          />

          <div className="relative grid md:grid-cols-[1.2fr_1fr] gap-6 md:gap-8 p-5 sm:p-8 md:p-10 items-center">
            <div>
              <span className="inline-block bg-red-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow mb-2 md:mb-3">
                Recovery · Repairs · Restorations
              </span>
              <h2 className="text-xl sm:text-2xl md:text-4xl font-bold leading-tight mb-2 md:mb-3">
                Truck down? The Truck Factory has you covered.
              </h2>
              <p className="text-blue-100 text-sm md:text-base mb-4 md:mb-5 max-w-lg">
                Our partners at{' '}
                <span className="font-semibold text-white">The Truck Factory</span> handle
                everything from breakdown recovery to full body-off restorations — trusted
                Australian workshop, no-nonsense quotes.
              </p>
              <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-6 max-w-lg">
                {services.map((s) => {
                  const Icon = s.icon;
                  return (
                    <div
                      key={s.label}
                      className="flex items-center gap-2 text-sm bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2"
                    >
                      <Icon className="w-4 h-4 text-red-300 flex-shrink-0" />
                      <span className="font-medium">{s.label}</span>
                    </div>
                  );
                })}
              </div>
              <a
                href="https://thetruckfactory.com.au/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-3 rounded-full shadow-lg transition-all hover:shadow-xl"
                data-testid="home-truck-factory-cta"
              >
                Click here for quotes
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="hidden md:flex justify-center">
              <a
                href="https://thetruckfactory.com.au/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white rounded-2xl p-5 shadow-xl text-center max-w-[240px] hover:shadow-2xl transition-shadow"
              >
                <p className="text-[10px] font-bold uppercase tracking-widest text-red-700 mb-3">
                  Trusted partner
                </p>
                <img
                  src={TRUCK_FACTORY_LOGO}
                  alt="The Truck Factory"
                  className="mx-auto max-h-24 object-contain"
                  data-testid="home-truck-factory-logo"
                />
                <p className="mt-3 text-[11px] text-gray-500 leading-relaxed">
                  thetruckfactory.com.au
                </p>
              </a>
            </div>
          </div>
        </div>

        {/* Partners row */}
        <div className="mt-8 sm:mt-10" data-testid="home-partners-strip">
          <p className="text-center text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-4">
            Our trusted partners
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            <a
              href="https://thetruckfactory.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm hover:shadow-md hover:border-red-300 transition-all"
              data-testid="partner-truck-factory"
            >
              <img
                src={TRUCK_FACTORY_LOGO}
                alt="The Truck Factory"
                className="h-12 w-auto object-contain"
              />
              <div className="text-left">
                <p className="text-sm font-bold text-[#1e3a5f]">The Truck Factory</p>
                <p className="text-[11px] text-gray-500">Recovery · Repairs · Restorations</p>
              </div>
            </a>

            <a
              href="/insurance-quotes"
              className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm hover:shadow-md hover:border-red-300 transition-all"
              data-testid="partner-elders"
            >
              <img
                src={ELDERS_LOGO}
                alt="Elders Insurance"
                className="h-12 w-auto object-contain"
              />
              <div className="text-left">
                <p className="text-sm font-bold text-[#1e3a5f]">Elders Insurance</p>
                <p className="text-[11px] text-gray-500">Machinery · Load · Liability</p>
              </div>
            </a>

            <a
              href="https://www.kptcc.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm hover:shadow-md hover:border-red-300 transition-all"
              data-testid="partner-kptcc"
            >
              <img
                src={KPTCC_LOGO}
                alt="Kimberley Priest Transport Compliance Consulting"
                className="h-12 w-auto object-contain"
              />
              <div className="text-left">
                <p className="text-sm font-bold text-[#1e3a5f]">KP Transport Compliance</p>
                <p className="text-[11px] text-gray-500">Kimberley Priest · Consulting</p>
              </div>
            </a>

            <a
              href="https://www.johnsonstrucks.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm hover:shadow-md hover:border-red-300 transition-all"
              data-testid="partner-johnsons-trucks"
            >
              <img
                src={JOHNSONS_LOGO}
                alt="Johnson's Trucks"
                className="h-12 w-auto object-contain"
              />
              <div className="text-left">
                <p className="text-sm font-bold text-[#1e3a5f]">Johnson's Trucks</p>
                <p className="text-[11px] text-gray-500">
                  <a
                    href="tel:0458219434"
                    onClick={(e) => e.stopPropagation()}
                    className="hover:text-red-600 hover:underline"
                  >
                    0458 219 434
                  </a>
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TruckFactoryStrip;
